import { render } from "./AdPaymentSuccess.vue?vue&type=template&id=85c1ef4e&scoped=true"
import script from "./AdPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./AdPaymentSuccess.vue?vue&type=script&lang=js"

import "./AdPaymentSuccess.vue?vue&type=style&index=0&id=85c1ef4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c1ef4e"]])

export default __exports__